import React from 'react';

import { Box, BoxProps } from '@opendoor/bricks/core';
import { space } from '@opendoor/bricks/theme/eero';

/**
 * TODO: Add documentation
 *
 * component-test-check-ignore
 */
export const StickyFooter: React.FC<BoxProps> = (props) => (
  <Box
    mt={[11, null, null, null, 0]}
    p={[`${space[10]}px ${space[7]}px ${space[11]}px`, null, null, null, 0]}
    {...props}
  />
);
